<div>
  <h1 class="main-title">
    <div class="circle circle-primary">
      <img src="assets/icons/toolbox-icon.svg" alt="">
    </div>
    Criterios de aceptación
  </h1>
  <div class="flex justify-between items-center mb-2">
    <h2 class="main-subtitle">Nuevo Criterio de Aceptación</h2>
    <a routerLink="/acceptance-criteria" class="button button-outlined-primary">
      <i class="fa-solid fa-chevron-left" alt=""></i> Volver
    </a>
  </div>

  <div class="single-page-content">
    <form [formGroup]="criteriaForm" (ngSubmit)="onSubmit()">
      <div class="mb-4">
        <label class="block text-gray-700">Nombre<span class="text-danger-500">*</span></label>
        <input formControlName="name" class="input">
        <div *ngIf="name?.invalid && (name?.dirty || name?.touched)" class="text-danger-500 text-sm">
          El nombre es obligatorio.
        </div>
      </div>
      <div class="mb-4">
        <label class="block text-gray-700">Descripción<span class="text-danger-500">*</span></label>
        <textarea formControlName="description" class="textarea"></textarea>
        <div *ngIf="description?.invalid && (description?.dirty || description?.touched)" class="text-danger-500 text-sm">
          La descripción es obligatoria.
        </div>
      </div>
      <div class="mb-4">
        <label class="block text-gray-700">Archivo</label>
        <input type="file" (change)="onFileSelected($event)" />
      </div>      
      <div *ngIf="errorMessage" class="mb-4 text-danger-500">
        {{ errorMessage }}
      </div>
      <div class="flex items-center justify-end">
        <button type="submit" class="button button-success">
          Crear criterio
        </button>
      </div>
    </form>
  </div>
</div>
